import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Trip } from "@mapmycustomers/shared/types/entity";
import DistanceRecord from "@mapmycustomers/shared/types/entity/Distance";
import { UpdateTripPayload } from "@mapmycustomers/shared/types/entity/Trip";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import DistanceTravelledCardConfiguration from "@app/types/dashboard/cards/distanceTravelled/DistanceTravelledCardConfiguration";
import DistanceTravelledCardData from "@app/types/dashboard/cards/distanceTravelled/DistanceTravelledCardData";
import Scope from "@app/types/dashboard/Scope";

export const fetchDistanceTravelledCardData = createAction(
  "@dashboard/fetchDistanceTravelledCardData"
)<{
  callback: (data: DistanceTravelledCardData) => void;
  configuration: DistanceTravelledCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showDistanceTravelledDrillDown = createAsyncAction(
  "@dashboard/showDistanceTravelledCardDrillDownModal/request",
  "@dashboard/showDistanceTravelledCardDrillDownModal/success",
  "@dashboard/showDistanceTravelledCardDrillDownModal/failure"
)<
  {
    configuration: DistanceTravelledCardConfiguration;
    customDateRange?: DateRange;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideDistanceTravelledDrillDown = createAction(
  "@dashboard/hideDistanceTravelledCardDrillDownModal"
)<void>();

export const fetchDistanceTravelledCardDrillDownData = createAsyncAction(
  "@dashboard/fetchDistanceTravelledCardDrillDownData/request",
  "@dashboard/fetchDistanceTravelledCardDrillDownData/success",
  "@dashboard/fetchDistanceTravelledCardDrillDownData/failure"
)<
  // trips with Mileage Tracker, location distances without: the saga picks the branch
  DrillDownListFetcherPayload<DistanceRecord | Trip>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyDistanceTravelledDrillDownListViewSettings = createAction(
  "@dashboard/applyDistanceTravelledDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportDistanceTravelledCardDrillDownData = createAction(
  "@dashboard/exportDistanceTravelledCardData"
)<{
  configuration: DistanceTravelledCardConfiguration;
  scope: Scope;
}>();

export const updateDistanceTravelledTrip = createAsyncAction(
  "@dashboard/updateDistanceTravelledTrip/request",
  "@dashboard/updateDistanceTravelledTrip/success",
  "@dashboard/updateDistanceTravelledTrip/failure"
)<
  { entity: UpdateTripPayload; onFailure?: () => void; onSuccess?: (trip: Trip) => void },
  Trip,
  unknown
>();

export type DistanceTravelledCardActions = ActionType<
  | typeof applyDistanceTravelledDrillDownListViewSettings
  | typeof exportDistanceTravelledCardDrillDownData
  | typeof fetchDistanceTravelledCardData
  | typeof fetchDistanceTravelledCardDrillDownData
  | typeof hideDistanceTravelledDrillDown
  | typeof showDistanceTravelledDrillDown
  | typeof updateDistanceTravelledTrip
>;
